(() => {
  const pending = new WeakMap();

  function tierFor(quantity) {
    if (quantity >= 4) return { quantity: 4, percent: 20, label: '4+ item' };
    if (quantity === 3) return { quantity: 3, percent: 15, label: '3-item' };
    if (quantity === 2) return { quantity: 2, percent: 10, label: '2-item' };
    return null;
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: currency || 'USD', currencyDisplay: 'narrowSymbol'
      }).format(Math.max(Number(cents || 0), 0) / 100);
    } catch (_) {
      return `${currency || 'USD'} ${(Math.max(Number(cents || 0), 0) / 100).toFixed(2)}`;
    }
  }

  function normalizeMarkup(block) {
    const cards = [...block.querySelectorAll('[data-tfq-tier]')];
    const buyTwo = cards.find((card) => card.dataset.quantity === '2');
    const buyThree = cards.find((card) => card.dataset.quantity === '3');
    const buyFour = cards.find((card) => card.dataset.quantity === '4');

    if (buyTwo) {
      buyTwo.dataset.percent = '10';
      const off = buyTwo.querySelector('.tfq-bundle__tier-off');
      if (off) off.textContent = '10% OFF';
    }
    if (buyThree) {
      buyThree.dataset.percent = '15';
      const off = buyThree.querySelector('.tfq-bundle__tier-off');
      if (off) off.textContent = '15% OFF';
    }
    if (buyFour) {
      buyFour.dataset.percent = '20';
      const qty = buyFour.querySelector('.tfq-bundle__tier-qty');
      const off = buyFour.querySelector('.tfq-bundle__tier-off');
      const note = buyFour.querySelector('small');
      if (qty) qty.textContent = 'Buy 4+';
      if (off) off.textContent = '20% OFF';
      if (note) note.textContent = '4 or more items';
    }
    cards.filter((card) => !['2', '3', '4'].includes(card.dataset.quantity)).forEach((card) => card.remove());
    [...block.querySelectorAll('[data-tfq-progress-step]')].slice(4).forEach((step) => step.remove());

    const codeFour = block.getAttribute('data-tfq-code-4') || 'TWIDDLY4';
    block.setAttribute('data-tfq-code-5', codeFour);
  }

  async function render(block) {
    normalizeMarkup(block);
    let cart;
    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      cart = await response.json();
    } catch (_) {
      return;
    }

    const quantity = Math.max(Number(cart.item_count || 0), 0);
    const tier = tierFor(quantity);
    const count = block.querySelector('[data-tfq-count]');
    const status = block.querySelector('[data-tfq-status]');
    if (count) count.textContent = `${quantity} ${quantity === 1 ? 'item' : 'items'}`;

    block.querySelectorAll('[data-tfq-tier]').forEach((card) => {
      card.classList.toggle('is-active', Boolean(tier && Number(card.dataset.quantity) === tier.quantity));
    });
    block.querySelectorAll('[data-tfq-progress-step]').forEach((step, index) => {
      step.classList.toggle('is-filled', quantity >= index + 1);
    });

    if (!status) return;
    let html;
    if (tier) {
      const subtotal = Number(cart.items_subtotal_price || cart.original_total_price || cart.total_price || 0);
      const saving = Math.round(subtotal * tier.percent / 100);
      html = `<strong>${tier.percent}% OFF unlocked.</strong> Your ${tier.label} bundle is ready. Estimated saving: <strong>${money(saving, cart.currency)}</strong>.`;
    } else if (quantity === 1) {
      html = 'Add <strong>1 more product</strong> to unlock the 2-item bundle offer.';
    } else {
      html = 'Add any <strong>2 products</strong> to unlock your first bundle offer.';
    }
    if (status.innerHTML !== html) status.innerHTML = html;
    status.classList.toggle('is-unlocked', Boolean(tier));
  }

  function schedule(block) {
    clearTimeout(pending.get(block));
    pending.set(block, setTimeout(() => render(block), 40));
  }

  function init() {
    document.querySelectorAll('[data-tfq-bundle]').forEach((block) => {
      normalizeMarkup(block);
      if (!block.dataset.twThreeTierObserver) {
        block.dataset.twThreeTierObserver = 'true';
        const status = block.querySelector('[data-tfq-status]');
        const count = block.querySelector('[data-tfq-count]');
        const observer = new MutationObserver(() => schedule(block));
        if (status) observer.observe(status, { childList: true, subtree: true, characterData: true });
        if (count) observer.observe(count, { childList: true, subtree: true, characterData: true });
      }
      schedule(block);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('cart:update', init);
  document.addEventListener('cart:refresh', init);
  window.setTimeout(init, 700);
  window.setTimeout(init, 1800);
})();
